export default "__VITE_ASSET__DMB_8qeO__"